<template>
  <div>
    <Search @search="minSearchSubmit" @reset="resetQueryParams">
      <el-form :model="queryParams" ref="refForm" label-width="80px">
        <el-row :gutter="30">
          <el-col :span="8">
            <el-form-item label="设备唯一标识号" label-width="130px">
              <el-input
                type="text"
                placeholder="请输入设备唯一标识号"
                v-model="queryParams.equipmentIdentification"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="库房类型" label-width="130px">
              <el-select
                v-model="queryParams.storageType"
                placeholder="请选择库房类型"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="冷库（2℃—10℃）" value="冷库"></el-option>
                <el-option
                  label="冷冻库（-20℃- 0℃）"
                  value="冷冻库"
                ></el-option>
                <el-option label="阴凉库（20℃以下）" value="阴凉库"></el-option>
                <el-option label="常温库（0℃—30℃）" value="常温库"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Search>
    <el-button type="primary" @click="addList()">添加设备</el-button>
    <div class="table-container">
      <el-table :data="entList" style="width: 100%">
        <el-table-column type="index" label="序号" />
        <el-table-column
          prop="equipment_identification"
          label="设备唯一标识号"
        />
        <el-table-column prop="storage_type" label="库房类型" />
        <el-table-column prop="reserve1" label="库房名称" />
        <el-table-column prop="storage_address" label="库地址" />
        <el-table-column prop="temperature_upper" label="温度上限">
          <template slot-scope="scope">
            <span>{{
              scope.row.temperature_upper === '' ||
              scope.row.temperature_upper === null
                ? '未设置'
                : scope.row.temperature_upper
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="temperature_lower" label="温度下限">
          <template slot-scope="scope">
            <span>{{
              scope.row.temperature_lower === '' ||
              scope.row.temperature_lower === null
                ? '未设置'
                : scope.row.temperature_lower
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="humidity_upper" label="湿度上限">
          <template slot-scope="scope">
            <span>{{
              scope.row.humidity_upper === '' ||
              scope.row.humidity_upper === null
                ? '未设置'
                : scope.row.humidity_upper
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="humidity_lower" label="湿度下限">
          <template slot-scope="scope">
            <span>{{
              scope.row.humidity_lower === '' ||
              scope.row.humidity_lower === null
                ? '未设置'
                : scope.row.humidity_lower
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button type="text" @click="editList(scope.row)">编辑</el-button>
            <el-button type="text" @click="deleteList(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <div class="dialog">
      <el-dialog
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        :modal="false"
        @close="resetForm('refFormAdd')"
        width="400px"
      >
        <el-form
          :model="queryParamsAdd"
          :rules="rules"
          ref="refFormAdd"
          label-width="80px"
          size="mini"
          style="min-height:460px"
        >
          <el-row :gutter="30">
            <el-col :span="24">
              <el-form-item
                label="设备唯一标识号"
                label-width="130px"
                prop="equipmentIdentification"
              >
                <el-input
                  type="text"
                  placeholder="请输入设备唯一标识号"
                  v-model="queryParamsAdd.equipmentIdentification"
                  v-show="inputShow"
                />
                <span v-show="!inputShow">{{
                  queryParamsAdd.equipmentIdentification
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="库房类型"
                label-width="130px"
                prop="storageType"
              >
                <el-select
                  v-model="queryParamsAdd.storageType"
                  placeholder="请选择库房类型"
                >
                  <el-option label="冷库（2℃—10℃）" value="冷库"></el-option>
                  <el-option
                    label="冷冻库（-20℃- 0℃）"
                    value="冷冻库"
                  ></el-option>
                  <el-option
                    label="阴凉库（20℃以下）"
                    value="阴凉库"
                  ></el-option>
                  <el-option
                    label="常温库（0℃—30℃）"
                    value="常温库"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="库房名称" label-width="130px">
                <el-input
                  type="text"
                  placeholder="请输入库房名称"
                  v-model="queryParamsAdd.reserve1"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="库地址" label-width="130px">
                <el-input
                  type="text"
                  placeholder="请输入库地址"
                  v-model="queryParamsAdd.storageAddress"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-checkbox v-model="temperatureChecked"
                >启用温度报警</el-checkbox
              >
              <el-form-item
                label="温度下限"
                prop="temperatureLower"
                v-if="showtemperatureLower"
              >
                <el-input
                  type="text"
                  placeholder="请输入温度下限"
                  v-model="queryParamsAdd.temperatureLower"
                  :disabled="disabled"
                />
                <span class="icon">℃</span>
              </el-form-item>
              <el-form-item
                label="温度上限"
                prop="temperatureUpper"
                v-if="showtemperatureLower"
              >
                <el-input
                  type="text"
                  placeholder="请输入温度上限"
                  v-model="queryParamsAdd.temperatureUpper"
                  :disabled="disabled"
                />
                <span class="icon">℃</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-checkbox v-model="humidityChecked">启用湿度报警</el-checkbox>
              <el-form-item
                label="湿度下限"
                prop="humidityLower"
                v-if="showhumidityChecked"
              >
                <el-input
                  type="text"
                  placeholder="请输入湿度下限"
                  v-model="queryParamsAdd.humidityLower"
                  :disabled="humidityUpperdisabled"
                />
                <span class="icon">%RH</span>
              </el-form-item>
              <el-form-item
                label="湿度上限"
                prop="humidityUpper"
                v-if="showhumidityChecked"
              >
                <el-input
                  type="text"
                  placeholder="请输入湿度上限"
                  v-model="queryParamsAdd.humidityUpper"
                  :disabled="humidityUpperdisabled"
                />
                <span class="icon">%RH</span>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="table">
              <el-button
                type="primary"
                @click="submitForm('refFormAdd')"
                class="overSubmit"
                >确认</el-button
              >
              <el-button
                type="primary"
                @click="resetForm('refFormAdd')"
                class="overSubmit"
                plain
                >取消</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Search from 'components/search/search';
import searchMixin from 'mixin/search';
import PaginationMixin from 'mixin/pagination';
const checkNum = (rule, value, callback) => {
  const reg = /^(0|\+?[1-9][0-9]*)$/;
  if (!reg.test(value)) {
    callback(new Error('仅限整数'));
  } else {
    callback();
  }
};
export default {
  props: ['listid'],
  data() {
    return {
      entList: [],
      addVisible: false,
      temperatureChecked: false,
      humidityChecked: false,
      disabled: true,
      humidityUpperdisabled: true,
      inputShow: true,
      showtemperatureLower: false,
      showhumidityChecked: false,
      inputFun: '',
      checkList: [],
      queryParams: {
        equipmentIdentification: '',
        storageType: ''
      },
      queryParamsAdd: {
        equipmentIdentification: '',
        storageType: '',
        storageAddress: '',
        temperatureUpper: '',
        temperatureLower: '',
        humidityUpper: '',
        humidityLower: '',
        temperatureStatus: '',
        humidityStatus: '',
        reserve1: ''
      },
      id: '',
      rules: {
        equipmentIdentification: [
          { required: true, message: '请输入设备唯一标识号', trigger: 'blur' }
        ],
        storageType: [
          { required: true, message: '请选择库房类型', trigger: 'change' }
        ],
        temperatureUpper: [
          {
            required: true,
            message: '请输入正确温度上限（仅限整数）',
            trigger: 'blur',
            validator: checkNum
          }
        ],
        temperatureLower: [
          {
            required: true,
            message: '请输入正确温度下限（仅限整数）',
            trigger: 'blur',
            validator: checkNum
          }
        ],
        humidityUpper: [
          {
            required: true,
            message: '请输入正确湿度上限（仅限整数）',
            trigger: 'blur',
            validator: checkNum
          }
        ],
        humidityLower: [
          {
            required: true,
            message: '请输入正确湿度下限（仅限整数）',
            trigger: 'blur',
            validator: checkNum
          }
        ]
      }
    };
  },
  mixins: [searchMixin, PaginationMixin],
  mounted() {
    this.querySubmit();
  },
  methods: {
    querySubmit() {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: this.pageSize
            },
            params: {
              ...this.queryParams,
              handlerName: 'equipment_list',
              entId: this.listid
            }
          })
        }
      }).then(res => {
        this.entList = res.list ? [...res.list] : [];
        this.total = res.total || 0;
      });
    },
    // 添加设备
    addList() {
      this.inputShow = true;
      this.addVisible = true;
      this.id = '';
      this.temperatureChecked = false;
      this.humidityChecked = false;
      for (const key in this.queryParamsAdd) {
        this.queryParamsAdd[key] = '';
      }
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$request({
            url: 'rest/temperatureHumidity/mergerTemperatureHumidity',
            data: {
              json: JSON.stringify({
                params: {
                  temperatureList: [
                    {
                      ...this.queryParamsAdd,
                      entId: this.listid,
                      id: this.id
                    }
                  ]
                }
              })
            }
          }).then(res => {
            this.addVisible = false;
            this.querySubmit();
          });
        } else {
          return false;
        }
      });
    },
    // 编辑
    editList(row) {
      this.addVisible = true;
      this.inputShow = false;
      this.id = row.id;
      this.queryParamsAdd.equipmentIdentification =
        row.equipment_identification;
      this.queryParamsAdd.humidityLower = row.humidity_lower;
      this.queryParamsAdd.humidityStatus = row.humidity_status;
      this.queryParamsAdd.humidityUpper = row.humidity_upper;
      this.queryParamsAdd.storageAddress = row.storage_address;
      this.queryParamsAdd.storageType = row.storage_type;
      this.queryParamsAdd.temperatureLower = row.temperature_lower;
      this.queryParamsAdd.temperatureStatus = row.temperature_status;
      this.queryParamsAdd.temperatureUpper = row.temperature_upper;
      this.queryParamsAdd.reserve1 = row.reserve1;
      if (row.temperature_status === '1') {
        this.temperatureChecked = true;
      }
      if (row.humidity_status === '1') {
        this.humidityChecked = true;
      }
    },
    // 删除
    deleteList(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$request({
          url: 'rest/temperatureHumidity/deleteTemperatureHumidity',
          data: {
            json: JSON.stringify({
              params: {
                delIds: row.id
              }
            })
          }
        }).then(res => {
          this.querySubmit();
        });
      });
    },
    // 取消
    resetForm(formName) {
      this.addVisible = false;
      this.$refs[formName].resetFields();
      this.isShow1 = false;
      this.isShow = false;
    }
  },
  watch: {
    listid(newVal, oldVal) {
      this.listid = newVal;
      this.querySubmit();
    },
    temperatureChecked(newVal, oldVal) {
      if (newVal === true) {
        this.disabled = false;
        this.showtemperatureLower = true;
        this.queryParamsAdd.temperatureStatus = '1';
      } else {
        this.disabled = true;
        this.showtemperatureLower = false;
        this.queryParamsAdd.temperatureStatus = '0';
        this.queryParamsAdd.temperatureUpper = '';
        this.queryParamsAdd.temperatureLower = '';
      }
    },
    humidityChecked(newVal, oldVal) {
      if (newVal === true) {
        this.humidityUpperdisabled = false;
        this.showhumidityChecked = true;
        this.queryParamsAdd.humidityStatus = '1';
      } else {
        this.humidityUpperdisabled = true;
        this.showhumidityChecked = false;
        this.queryParamsAdd.humidityStatus = '0';
        this.queryParamsAdd.humidityUpper = '';
        this.queryParamsAdd.humidityLower = '';
      }
    }
  },
  components: {
    Search
  }
};
</script>

<style lang="stylus" scoped>
.dialog
  .el-col
    min-height 0 !important
.table
  margin 0 auto
  text-align center
.inputClass
  border 1px solid #F56C6C
.icon
  position absolute
  right 5px
  top 1px
.pagination
  padding 20px
  background #fff
  text-align right
</style>
